import { useQuery, useQueryClient } from "@tanstack/react-query";
import { VendorService } from "src/services";
import { QueryParamsMapper } from "src/mappers";
import { queryKeys } from "src/constants";
import { DateTimeRange, VendorPaginationOptions, VendorsFiltersState } from "src/types";

const useVendors = (
  vendorService: VendorService,
  dateTimeRange?: DateTimeRange,
  filters?: VendorsFiltersState,
  paginationOptions?: VendorPaginationOptions
) => {
  const queryClient = useQueryClient();

  const queryParams = QueryParamsMapper.getVendorsQueryParams(dateTimeRange, filters, paginationOptions);

  const {
    data: paginatedVendors,
    error: fetchError,
    isLoading
  } = useQuery({
    queryKey: queryKeys.paginatedVendors(queryParams),
    queryFn: () => vendorService.getVendors(queryParams)
  });

  const refreshVendors = () => {
    queryClient.removeQueries({
      queryKey: queryKeys.paginatedVendors(),
      exact: false
    });
  };

  return { paginatedVendors, fetchError, isLoading, refreshVendors };
};

export { useVendors };
